module.exports = __webpack_public_path__ + "fonts/icomoon.79a3d88.ttf";